import {
	FETCH_FACTURATION_BEGIN,
	FETCH_FACTURATION_ERROR,
	FETCH_FACTURATION_SUCCESS,
} from "../actions/facturationActions"

const initialState = {
	ateliers: [],
	depannages: [],
	locations: [],
	fetchFacturation: {
		loading: false,
		error: false,
	},
}

export default function facturationReducer(state = initialState, action) {
	let nextState
	switch (action.type) {
		case FETCH_FACTURATION_BEGIN:
			return {
				...state,
				fetchFacturation: {
					loading: true,
					error: false,
				},
			}

		case FETCH_FACTURATION_SUCCESS:
			nextState = {
				...state,
				fetchFacturation: {
					loading: false,
					error: false,
				},
			}
			// Le back renvoie une seule clé selon le type demandé : on ne
			// remplace que la tranche concernée, les autres restent intactes.
			if (Object.keys(action.payload).includes("ateliers"))
				nextState.ateliers = action.payload.ateliers
			if (Object.keys(action.payload).includes("locations"))
				nextState.locations = action.payload.locations
			if (Object.keys(action.payload).includes("depannages"))
				nextState.depannages = action.payload.depannages
			return nextState

		case FETCH_FACTURATION_ERROR:
			return {
				...state,
				fetchFacturation: {
					loading: false,
					error: action.payload.error,
				},
			}
		default:
			return state
	}
}
